import { modules, homepage } from './context';

export const PAGE_FILTER = null;
export const WDS_PORT = 4000;
export const PROXY_URL = 'https://www.powerdistributors.com/';
export const isProd = process.env.NODE_ENV !== 'development';
export const htmlConfig = {
    ...modules,
    homepage,
};

// Price Break example: 100005
// LTL Only: 44T977-0009-G1
// Ground Only: 100005 (does not add message on current site (for now))
// disallow e-commerce: 808340
// sell pack: 253, 491588B

// dropdown customize
// https://github.com/harvesthq/chosen
// BS, 1723900SM ---> id = 0
// 5043k(a-k) ----> supersedes from

// Sitefintiy - custom attributes
// https://docs.sitefinity.com/for-developers-use-the-value-of-a-custom-attribute



// WEBPACK FOOTER //
// ./app/config/config.js